module.exports = __webpack_public_path__ + "static/media/success_unselected.606bbd23.svg";